module.exports = __webpack_public_path__ + "img/地砖.31799d18.webp";